// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import AddFundingSourceToDwollaBySuperAdminReduxForm from '../layout/reduxForm/AddFundingSourceToDwollaBySuperAdmin';
import ControlButtonsSection from '../layout/reduxForm/section/addFundingSourceToDwollaBySuperAdmin/ControlButtonsSection';
import onSubmit from '../../utils/reduxForm/onSubmit/addFundingSourceToDwollaBySuperAdmin';

const AddFundingSourceToDwollaBySuperAdmin = ({
  modalState,
  toggleModal,
}) => {
  const closeModal = () => {
    toggleModal(false, 'addFundingSourceToDwollaBySuperAdmin');
  };

  if (!modalState.isOpen) {
    return null;
  }

  return (
    <div className="popup_block dashboard-modal dashboard-modal--funds dashboard-modal--funding-source showed">
      <div className="popup_container">
        <div className="popup_head">
          <div className="popup_title">Add Funding Source</div>
          <button type="button" className="close_btn" aria-label="close" onClick={closeModal}>
            ×
          </button>
        </div>
        <div className="dashboard-modal-form-scroll">
          <AddFundingSourceToDwollaBySuperAdminReduxForm onSubmit={onSubmit} />
          <p className="dashboard-modal-hint">
            Verification of micro deposits usually takes 2–3 days.
          </p>
        </div>
        <ControlButtonsSection closeModal={closeModal} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  profile: state.profile,
  modalState: state.modalState.addFundingSourceToDwollaBySuperAdmin,
});

export default connect(mapStateToProps, {
  toggleModal,
})(AddFundingSourceToDwollaBySuperAdmin);
